import React from "react";
import {CircleUser} from 'lucide-react';
import { useT } from "@/lib/config/useTranslations";
import { useLanguage } from "@/lib/config/useLanguage";

export default function BtnAccount() {
    const { t } = useT();
    const { localizePath } = useLanguage();

    return (
        <a
            href={localizePath('/profile')}
            className="rounded-xl flex flex-row items-center gap-2 bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        >
            <CircleUser/>
            <span className={'text-small hidden xl:inline'}>{t('common.account')}</span>
        </a>
    )
}